import CryptoJS from 'crypto-js';

export const Encrypt = (plainData) => {
  return CryptoJS.AES.encrypt(
    plainData,
    process.env.REACT_APP_DARPAN_TOKEN_ENCRYPT_KEY ? process.env.REACT_APP_DARPAN_TOKEN_ENCRYPT_KEY : '',
  ).toString();
};

export const Decrypt = (encrypted) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_DARPAN_TOKEN_ENCRYPT_KEY).toString(),
  );
};
